<template>
  <el-dialog title="添加图片" :visible.sync="dialogVisible" width="30%" @close="handleClose">
    <el-form label-width="100px">
      <el-form-item label="选择图片">
        <el-upload :action="''" :auto-upload="false" :on-change="handleImageUpload" :show-file-list="false"
          accept="image/*">
          <el-button size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过2MB</div>
        </el-upload>
      </el-form-item>
      <el-form-item label="图片预览">
        <div v-if="imagePreview" class="image-preview-container">
          <img :src="imagePreview" alt="图片预览" style="max-width: 100%; max-height: 150px; object-fit: contain;">
        </div>
        <div v-else class="image-placeholder">
          请选择图片
        </div>
      </el-form-item>
      <el-form-item label="图片大小">
        <el-input-number v-model="imageSize" :min="50" :max="400" :step="10"></el-input-number>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取消</el-button>
      <el-button type="primary" @click="handleAdd" :disabled="!imageFile">添加图片</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'ImageUploadDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    imageFile: {
      type: [Object, File],
      default: null
    },
    imagePreview: {
      type: String,
      default: ''
    },
    imageSize: {
      type: Number,
      default: 150
    }
  },
  data() {
    return {
      dialogVisible: this.visible
    };
  },
  watch: {
    visible: {
      handler(newVal) {
        this.dialogVisible = newVal;
      },
      immediate: true
    },
    dialogVisible(newVal) {
      this.$emit('update:visible', newVal);
    }
  },
  methods: {
    // 处理图片上传
    handleImageUpload(file) {
      // 检查文件类型
      const isImage = file.raw.type.indexOf('image/') === 0;
      if (!isImage) {
        this.$message.error('只能上传图片文件');
        return;
      }

      // 检查文件大小
      const isLt2M = file.raw.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error('图片大小不能超过 2MB!');
        return;
      }

      // 保存文件并生成预览
      this.$emit('update-file', file.raw);

      const reader = new FileReader();
      reader.onload = (e) => {
        this.$emit('update-preview', e.target.result);
      };
      reader.readAsDataURL(file.raw);
    },

    // 添加图片
    handleAdd() {
      if (!this.imageFile) {
        this.$message.warning('请选择图片');
        return;
      }

      // 发送添加事件
      this.$emit('add');

      // 关闭弹框
      this.dialogVisible = false;
    },

    // 取消操作
    handleCancel() {
      this.dialogVisible = false;
    },

    // 关闭弹框
    handleClose() {
      this.dialogVisible = false;
    }
  }
};
</script>

<style scoped>
/* 弹框样式 */
.dialog-footer {
  text-align: center;
}

/* 图片预览样式 */
.image-preview-container {
  width: 100%;
  height: 150px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #e4e7ed;
  border-radius: 3px;
  overflow: hidden;
  background-color: #f5f7fa;
}

/* 图片占位符样式 */
.image-placeholder {
  width: 100%;
  height: 150px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px dashed #dcdfe6;
  border-radius: 3px;
  color: #909399;
  background-color: #f5f7fa;
}
</style>